export default {
  MAX_WIDTH: 640,
}
